import { render, staticRenderFns } from "./PhysiotherapeuticView.vue?vue&type=template&id=988bb5c8&"
import script from "./PhysiotherapeuticView.vue?vue&type=script&lang=js&"
export * from "./PhysiotherapeuticView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports